export default "__VITE_ASSET__B7MjtJCB__"